/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do header 
 */
export default styled.header`
  /* border-bottom: 1px solid #e5e5e5; */
  height: 56px;
  overflow: hidden;
  display: flex;
  margin-bottom: 10px;

  > button {
    background: none;
    border: none;
    padding: 20px 15px 20px 15px;
  }

  h1 {
    padding: 18px 0;
    margin: 0;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
  }
`;
